import { FuseNavigationItem } from '@fuse/components/navigation';

const navigation: FuseNavigationItem[] = [
  {
    id: 'tenders',
    title: 'Bandi',
    type: 'basic',
    icon: 'heroicons_outline:document',
    link: '/tenders',
  },
  {
    id: 'reports',
    title: 'Segnalazioni',
    type: 'basic',
    icon: 'heroicons_outline:exclamation-circle',
    link: '/reports',
  },
  // {
  //   id: 'monitoring',
  //   title: 'Monitoraggio',
  //   type: 'basic',
  //   icon: 'heroicons_outline:chart-bar',
  //   link: '/monitors',
  // },
  {
    id: 'business-owners',
    title: 'Utenti',
    type: 'basic',
    icon: 'heroicons_outline:user-group',
    link: '/business-owners',
  },
  {
    id: 'users',
    title: 'Operatori',
    type: 'basic',
    icon: 'heroicons_outline:wrench-screwdriver',
    link: '/users',
    meta: { requiredRoles: ['Admin'] },
  },
  {
    id: 'bots',
    title: 'Bot',
    type: 'basic',
    icon: 'heroicons_outline:cpu-chip',
    link: '/bots',
    meta: { requiredRoles: ['Admin'] },
  },
  {
    id: 'crm',
    title: 'CRM',
    type: 'basic',
    icon: 'heroicons_outline:identification',
    link: '/crm',
    meta: { requiredRoles: ['Admin', 'Crm'] },
  },
];

//CUSTOMIZE AFTER; AVOID REDUNDANCY
export const defaultNavigation: FuseNavigationItem[] = navigation;
export const compactNavigation: FuseNavigationItem[] = navigation;
export const futuristicNavigation: FuseNavigationItem[] = navigation;
export const horizontalNavigation: FuseNavigationItem[] = navigation;
